// extracted by mini-css-extract-plugin
export default {"dltBtn":"More_dltBtn__Bdd7K","moreBtn":"More_moreBtn__B3s3W"};